import PricingHeader from "../../components/Layouts/PricingHeader";
import Header from "../../components/Layouts/Header";
import NewsRoomDetailsPage from "../../components/Newsroom/NewsRoomDetails";
import BottomBar from "../../components/Layouts/BottomBar";
import PricingFooter from "../../components/Layouts/PricingFooter";
import "../Newsroom/Newsroom.css";

const NewsRoomDetails = () => {
  return (
    <>
      <div className="newsroom_page">
        <Header />
        <NewsRoomDetailsPage />
        <BottomBar className="bottom-bar-spacing" />
        <PricingFooter />
      </div>
    </>
  );
};

export default NewsRoomDetails;
